import { useState } from "react";
import { classNames, localeMoment } from "../../helpers";
import SessionModel from "../../api/models/SessionModel";
import { BookOpenIcon } from "@heroicons/react/outline";
import { getSessionState } from "./helper";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ActiveSessionTimeStatus from "./ActiveSessionTimeStatus";
type SessionCardProps = {
  session: SessionModel;
  sessionNumber?: number;
};

export default function SessionCardHome({
  session,
  sessionNumber,
}: SessionCardProps) {
  const { t } = useTranslation();
  const LocalBasePath = "page.student.dashboard.room";
  const [sessionStarted, setSessionStarted] = useState(false);
  return (
    <li
      className={classNames(
        "bg-white  relative overflow-hidden	  h-full flex  flex-col justify-between ",
        session.isScheduled && "opacity-50 ",
        session.isDone || session.isInProgress ? "hover:bg-gray-100" : "",
        !sessionStarted && session.isInProgress
          ? "border  rounded-lg border-blue-600"
          : ""
      )}
      data-cy="activeSessionCard"
      data-cy-session-status={session.status}
      data-cy-session-id={session.id}
    >
      <div className="relative px-6 py-5  flex flex-col    justify-between     focus-within:ring-2 focus-within:ring-inset focus-within:ring-brandblue-500">
        <div className="flex-shrink-0  flex  flex-col justify-between">
          <div className="flex-shrink-0  flex w-full items-center justify-between">
            <h1
              className={classNames(
                "font-bold text-2xl flex",
                session.isComing && "text-brandblue-900"
              )}
            >
              <span>#</span>
              <span>
                {session?.session_number
                  ? session?.session_number
                  : sessionNumber}
              </span>
            </h1>
            {getSessionState(session.status!)}
          </div>
          {session.isDone && (
            <div
              className={classNames(
                session.isComing && "text-brandblue-500 ",
                "py-2 flex  items-center justify-between text-gray-700 "
              )}
            >
              <div className="  flex rounded-full items-center justify-between">
                <BookOpenIcon className="w-[18px]  rtl:ml-1 ltr:mr-1" />
                {session.endPageNumber ? session.endPageNumber : "00"}-
                {session.startPageNumber ? session.startPageNumber : "00"}
              </div>
            </div>
          )}
        </div>

        <div className="flex-1  flex flex-col  justify-between">
          <div
            className={classNames(
              session.isDone ? "hidden" : "invisible",
              "py-2 flex  items-center justify-between text-gray-700 "
            )}
          >
            <div className="  flex rounded-full items-center justify-between">
              <BookOpenIcon className="w-[18px]  rtl:ml-1 ltr:mr-1" />
              {session.endPageNumber ? session.endPageNumber : "00"}-
              {session.startPageNumber ? session.startPageNumber : "00"}
            </div>
          </div>

          <div
            className={classNames(
              session.isComing && "text-brandblue-500 ",
              "py-2 flex   items-center justify-between   text-gray-700 "
            )}
          >
            <div className="  flex rounded-full items-center justify-between">
              {localeMoment(session!.date!).format("dddd DD/MM/YYYY")}
            </div>
            <div className=" p-1  flex rounded-full items-center justify-between">
              {localeMoment(session!.start_time!).format("hh:mm A")}
            </div>
          </div>
        </div>
      </div>
      {session.isDone && (
        <div
          className="w-full bg-zinc-100	 text-sky-500	  flex justify-center   align-middle p-2 "
          data-cy="showDetails"
        >
          <Link to={"/student/dashboard/sessions/"} state={{ id: session.id }}>
            {t(`${LocalBasePath}.showSessionDetails`)}
          </Link>
        </div>
      )}
      {(session.isComing || session.isInProgress) && (
        <ActiveSessionTimeStatus
          className={
            session.isInProgress ? "w-full rounded-t-none justify-center" : ""
          }
          session={session}
        />
      )}
      {session.isScheduled && (
        <div className="w-full   bg-gray-100	 text-gray-300	  flex justify-center    align-middle p-2 ">
          <p>{t(`${LocalBasePath}.showSessionDetails`)}</p>
        </div>
      )}
    </li>
  );
}
